<mat-icon *ngIf="isFaIcon()" class="fa {{icon}}" aria-hidden="true"></mat-icon>
<mat-icon *ngIf="isMatIcon()" class="md-18" style="vertical-align: middle">{{icon}}</mat-icon>
